import { patchRouter } from "./patchRouter";

export const applyPatchCore = ({set, get, patch}) => {
    const state = get();

    const handler = patchRouter[patch.type];
    if (!handler) return;

    const streamKey = patch.streamKey;
    const incomingSeq = patch.sequence ?? 0;
    
    if (!streamKey) {
        return set(state => handler(state, patch, get));
    }

    const lastSeq = state.realtime.sequenceByStream[streamKey];
    const hasStream = lastSeq !== undefined;

    // // only guard if stream already exists
    if (hasStream && incomingSeq <= lastSeq) {
        return;
    }

    // update sequence tracker
    set(state => ({
        realtime: {
            ...state.realtime,
            sequenceByStream: {
                ...state.realtime.sequenceByStream,
                [streamKey]: incomingSeq,
            },
        },
    }))

    // apply patch
    set(state => handler(state, patch, get));
};